import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const STEPPER_ACTIVE_COLOR = '#1C9BE6'

export const Container = styled(Box)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 24px 24px 16px;
`

export const StepCell = styled(Box)`
  position: relative;
  display: flex;
  justify-content: center;
`

export const StepLine = styled(Box, { shouldForwardProp: (prop) => prop !== 'isActive' })<{ isActive?: boolean }>`
  ${({ theme, isActive }) => css`
    position: absolute;
    top: 11px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${isActive ? STEPPER_ACTIVE_COLOR : theme.colors.gray[300]};
  `}
`

export const StepCircle = styled(Box, { shouldForwardProp: (prop) => prop !== 'isActive' })<{ isActive?: boolean }>`
  ${({ theme, isActive }) => css`
    position: relative;
    z-index: 1;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: ${isActive ? theme.colors.lightest : theme.colors.gray.dark};
    background: ${isActive ? STEPPER_ACTIVE_COLOR : theme.colors.gray[200]};
  `}
`
